



















import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { IRussiaResortRegion } from '../plugins/store.russiaResort';
import { SVG, Element } from '@svgdotjs/svg.js';
import '@svgdotjs/svg.panzoom.js';
import IColors from '@/models/colors';
import Axios from 'axios';

@Component({})
export default class RussiaResortRegionPreviewMap extends Vue {
	@Prop({ required: true, type: Number }) public regionCode: number;
	public loaded = {
		loadSvg: false,
		mounted: false,
	};
	public get currentUUID() {
		return this.regionCode.toString().padStart(2, '0');
	}
	public get colors(): IColors {
		return this.$store.getters['russiaResort/getColors'];
	}
	public get region(): IRussiaResortRegion {
		return this.$store.getters['russiaResort/getRegionByCode'](this.regionCode);
	}
	public get grades(): number[] {
		return this.$store.getters['russiaResort/getDayInfo'].grades;
	}
	public get routeLink() {
		const route = `/russiaresort/region/${this.regionCode}`;
		if (this.$route.fullPath === route) {
			return '/russiaresort/';
		} else {
			return route;
		}
	}
	public get gradesArr(): Array<({ text: string, val: number })> {
		function flattenDeep(arr1) {
			return arr1.reduce((acc, val) => Array.isArray(val) ? acc.concat(flattenDeep(val)) : acc.concat(val), []);
		}
		const arr = this.grades.map((v, i, a) => {
			if (i === 0) {
				return { text: `> ${v.toLocaleString()}`, val: v + 1 };
			} else if (i === a.length - 1) {
				return [{ text: `${a[i].toLocaleString()} - ${a[i - 1].toLocaleString()}`, val: v }, { text: `< ${v.toLocaleString()}`, val: -1 }];
			} else {
				return { text: `${a[i].toLocaleString()} - ${a[i - 1].toLocaleString()}`, val: v };
			}
		});
		return flattenDeep(arr);
	}

	public created() {
		if (this.regionCode < 1) {
			return;
		}
		Axios.get(`/svg/russia_region_${this.currentUUID}.svg`)
			.then((r) => {
				const loadedSvg = new DOMParser()
					.parseFromString(r.data, 'image/svg+xml')
					.getElementsByTagName('svg')[0];
				loadedSvg.style.backgroundColor = 'white';
				(this.$refs.svg as SVGElement).outerHTML = loadedSvg.outerHTML;
				this.loaded.loadSvg = true;
			});
	}

	public mounted() {
		this.loaded.mounted = true;
	}

	@Watch('loaded', { deep: true })
	private onLoadChanged() {
		const color = '#86C5F9';
		if (this.loaded.loadSvg && this.loaded.mounted) {
			document.querySelectorAll(`#region${this.currentUUID} svg [region]`).forEach((v) => {
				const svgObj = SVG(v);
				svgObj.children().forEach((c) => {
					c.attr({ fill: color });
					c.css('fill', color);
				});
				svgObj.attr({ fill: color });
				svgObj.css('fill', color);
			});
		}
	}
}
